<template>
  <div>
    <b-card title="Examination Form">
      <b-row>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.name"
              placeholder="Enter Patient Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Gender" label-for="Gender">
            <v-select
              v-model="addForm.gender"
              :options="genderOption"
              placeholder="Gender"
            />
            <p v-if="errorForm.gender" class="ml-25 error">
              This field is required.
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Address" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.address"
              placeholder="Enter Patient Address"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Age" label-for="Name">
            <b-form-input
              id="Name"
              type="number"
              v-model="addForm.age"
              placeholder="Enter Patient Age"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Occupation" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.occupation"
              placeholder="Enter Patient Occupation"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Campanion Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.companionName"
              placeholder="Enter Patient Campanion Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient History" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.history"
              placeholder="Enter Patient History"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Add Button -->

      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button
          style="margin: auto"
          variant="primary"
          @click="printExaminationForm()"
        >
          Print Examination Form
          <b-icon-person-check class="ml-1"></b-icon-person-check>
        </b-button>
      </b-col>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfExaminationTable"
    >
      <section
        dir="ltr"
        class="pdf-content border border-dark font-modify m-5"
        slot="pdf-content"
      >
        <div
          class="border border-dark p-1"
          style="display: flex; justify-content: space-between"
        >
          <span>
            <pre style="background-color: white">
      Name: {{ addForm.name }}
      Sex: {{ addForm.gender }}
    </pre
            >
          </span>
          <span>
            <p></p>
            <p dir="rtl">عنوان المريض : {{ addForm.address }}</p>
          </span>
        </div>
        <div
          class="border border-dark p-1"
          style="display: flex; justify-content: space-between"
        >
          <span>
            <pre style="background-color: white">
      Age:{{ addForm.age }} 
    
    </pre
            >
          </span>
          <span>
            <p></p>
            <p dir="rtl">مهنة المريض : {{ addForm.occupation }}</p>
          </span>
        </div>
        <div
          class="border border-dark p-1"
          style="display: flex; justify-content: space-between"
        >
          <span>
            <pre style="background-color: white">
      History: {{ addForm.history }}
    
    </pre
            >
          </span>
          <span>
            <p></p>
            <p dir="rtl">اقرب شخص له: {{ addForm.companionName }}</p>
          </span>
        </div>

        <table style="width: 100%; table-layout: fixed">
          <tr style="height: 115px">
            <th>
              <div></div>
              <hr class="border border-dark" />
              <div></div>
            </th>
            <th></th>

            <th></th>
          </tr>
          <tr style="height: 115px">
            <th style="width: 100%">
              <div></div>
              <hr class="border border-dark" />
              <div></div>
            </th>
            <th></th>

            <th></th>
          </tr>
          <tr style="height: 30px">
            <th></th>
            <th></th>

            <th></th>
          </tr>
          <tr style="height: 30px">
            <th></th>
            <th></th>

            <th></th>
          </tr>
          <tr style="height: 30px">
            <th></th>
            <th></th>

            <th></th>
          </tr>
          <tr style="height: 30px">
            <th>systemic lines:</th>
            <th></th>

            <th></th>
          </tr>
          <tr style="height: 30px">
            <th></th>
            <th></th>

            <th></th>
          </tr>
        </table>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
  },

  data() {
    return {
      addForm: {
        name: '',
        age: '',
        history: '',
        companionName: '',
        adderss: '',
        occupation: '',
        gender: '',
      },
      errorForm: {
        name: '',
        age: '',
        history: '',
        companionName: '',
        adderss: '',
        occupation: '',
        gender: '',
      },
      genderOption: ['Male', 'Female'],
    };
  },
  methods: {
    printExaminationForm() {
      this.$refs.html2PdfExaminationTable.generatePdf();
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
